import React from 'react';
import { Box, Button, Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import { useLiveMatch } from '../LiveMatchContext.tsx';
import { TeamSide } from '../liveMatchTypes.ts';

interface Props {
  onBack?: () => void;
}

export default function ServiceSelectionStep({ onBack }: Props) {
  const { state, dispatch } = useLiveMatch();

  function select(side: TeamSide) {
    dispatch({ type: 'SET_SERVING_TEAM', payload: side });
  }

  const options: { side: TeamSide; name: string; color: string }[] = [
    { side: 'HOME', name: state.homeTeamName, color: state.homeShirtColor },
    { side: 'AWAY', name: state.awayTeamName, color: state.awayShirtColor },
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" mb={1}>
        Chi serve per primo?
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Seleziona la squadra che batte al primo punto del set.
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        {options.map((opt) => (
          <Card
            key={opt.side}
            variant="outlined"
            sx={{
              flex: 1,
              borderColor: state.servingTeam === opt.side ? 'primary.main' : 'divider',
              borderWidth: state.servingTeam === opt.side ? 2 : 1,
            }}
          >
            <CardActionArea onClick={() => select(opt.side)} sx={{ p: 2 }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <SportsTennisIcon sx={{ fontSize: 48, color: opt.color, mb: 1 }} />
                <Typography variant="subtitle1" fontWeight="bold">
                  {opt.name}
                </Typography>
                {opt.side === state.ourTeamSide && (
                  <Typography variant="caption" color="success.main">
                    La nostra squadra
                  </Typography>
                )}
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>

      {onBack && (
        <Box sx={{ mt: 3 }}>
          <Button onClick={onBack} color="inherit">
            ← Indietro
          </Button>
        </Box>
      )}
    </Box>
  );
}
